import { BenefitsTypewriter } from './BenefitsTypewriter'
import { AppsCarousel } from './AppsCarousel'
import { Button, buttonVariants } from '@/components/shadcn/button'
import { Link } from 'react-router'
import { useRestClient } from '@/contexts/QueryProvider'
import { useMemo, useState } from 'react'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/shadcn/avatar'
import { ENDPOINTS } from '@/util/endpoints'
import { AnimatePresence, motion } from 'motion/react'

export function HomePageContent() {
  const { getLandingApiGetPlatformExternal } = useRestClient()
  const { data } = getLandingApiGetPlatformExternal.useSuspenseQuery(undefined)
  const [showContacts, setShowContacts] = useState(false)

  const contacts = useMemo(
    () => data?.filter((item) => item.card.groupings.some((grouping) => grouping.value === 'Get in touch')),
    [data]
  )

  return (
    <motion.div layout className="flex h-full w-full flex-col items-center justify-between py-16">
      <BenefitsTypewriter />
      <motion.div layout className="flex w-full flex-col items-center justify-center gap-y-5">
        <motion.div layout className="flex justify-center gap-x-3">
          <Link to="/featured-apps" className={buttonVariants({ variant: 'ghost', size: 'lg' })}>
            See All Apps
          </Link>
          <Button size="lg" onClick={() => setShowContacts((show) => !show)}>
            Get in Touch
          </Button>
        </motion.div>

        <AnimatePresence mode="wait">
          <motion.div layout className="grid grid-flow-col gap-4">
            {showContacts && contacts && (
              <>
                {contacts.map(({ email, card: { title: name, description, image } }, index) => (
                  <motion.div
                    key={index}
                    className="flex items-center gap-4 rounded-lg bg-card p-2 shadow-md"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                  >
                    <Avatar className="h-14 w-14">
                      <AvatarImage
                        src={image ? `${ENDPOINTS.DOTNET}/rest/support/getImage?imageKey=${image}` : undefined}
                        alt={name}
                      />
                      <AvatarFallback className="bg-primary/10 font-medium text-primary">
                        {name
                          ?.split(' ')
                          .map((n) => n[0])
                          .join('')
                          .toUpperCase() || '?'}
                      </AvatarFallback>
                    </Avatar>
                    <div className="flex-1 leading-tight">
                      <p className="font-medium text-card-foreground">{name}</p>
                      {description && <p className="text-sm text-muted-foreground">{description}</p>}
                      <a
                        href={`mailto:${email}`}
                        className="text-sm text-primary transition-colors hover:text-primary/80"
                      >
                        {email}
                      </a>
                    </div>
                  </motion.div>
                ))}
              </>
            )}
          </motion.div>
        </AnimatePresence>
      </motion.div>
      <div className="flex flex-col items-center">
        {/* <h2 className="text-xl font-bold">Featured Apps:</h2> */}
        <AppsCarousel />
      </div>
    </motion.div>
  )
}
